import { graphql } from '../gql';

export const getConfirmedEvents = graphql(`
  query GetConfirmedEvents(
    $startTimeAfter: ISO8601DateTime
    $startTimeBefore: ISO8601DateTime
    $vendorIds: [ID!]!
  ) {
    searchEventVendors(
      input: {
        startTimeAfter: $startTimeAfter
        startTimeBefore: $startTimeBefore
        vendorIds: $vendorIds
        confirmed: true
        eventStatuses: [SCHEDULED, ACTIVE, IN_PROGRESS]
        vendorStatuses: [ACTIVE]
        perspective: RESTAURANT
        includeLiveDeliveryStatus: true
      }
    ) {
      error {
        code
        message
      }
      eventVendors(first: 50) {
        nodes {
          __typename
          id
          productType
          ... on PopupEventVendor {
            vendor {
              id
              internalName
            }
            productType
            popupEvent {
              id
              startTime: eventStartTime
              endTime: eventEndTime
              status
              account {
                id
                name
              }
            }
            eventLocation {
              id
              setupTime
              location {
                id
                name
                building {
                  id
                  name
                  address {
                    id
                    address1
                    address2
                    city
                    state
                    zipCode
                    country
                  }
                }
                cafeLocation {
                  id
                  name
                }
              }
            }
          }
          ... on SelectEventVendor {
            aggregateManifestKey
            vendor {
              id
              internalName
            }
            productType
            selectEvent {
              id
              startTime: endTime
              endTime: deliveryTime
              status
              readyAndBaggedTime
              account {
                id
                name
              }
              location {
                id
                name
                building {
                  id
                  name
                  address {
                    id
                    address1
                    address2
                    city
                    state
                    zipCode
                    country
                  }
                }
              }
            }
          }
          ... on CateringEventVendor {
            productType
            vendor {
              id
              internalName
            }
            event {
              id
              name
              startTime
              endTime
              status
              setupTime
              account {
                id
                name
              }
              location {
                id
                name
                building {
                  id
                  name
                  address {
                    id
                    address1
                    address2
                    city
                    state
                    zipCode
                    country
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);
